var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Actor } from '../../../../classes/actor/Actor';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { deserialize } from '../../../../utils/serializr/core/deserialize';
import { OrderedOptionUI } from './modules/OrderedOptionUI';
import { HideStrategy } from '../../../../classes/learnware/LearnwareEnums';
export class OrderedOption extends Actor {
    type = 'option';
    get task() {
        return this.parent;
    }
    get question() {
        return this.task.question;
    }
    // readonly optionActions = new BasicOptionActions(this);
    optionUI = new OrderedOptionUI(this);
    get shouldHideInStepOptionList() {
        const { hideStrategy } = this.task.step.valueOf;
        if (hideStrategy === HideStrategy.HideCorrectsOfPreviousSteps) {
            return !!this.task.steps.find(step => step.stepProgress.isStepCompleted && step.correctOption === this);
        }
        return false;
    }
    get shouldBeSelected() {
        return !!this.task.step && this.task.step.correctOption === this;
    }
    get isHovering() {
        return this.actorInteract.isActorHovering;
    }
    get optionIndex() {
        return this.task.options.indexOf(this);
    }
    get optionNumber() {
        return this.optionIndex + 1;
    }
    get shuffledOptionIndex() {
        return this.task.shuffledOptions.indexOf(this);
    }
    get shuffledOptionNumber() {
        return this.shuffledOptionIndex + 1;
    }
    get itemNumber() {
        return this.shuffledOptionNumber;
    }
    get unshuffledItemNumber() {
        return this.optionNumber;
    }
    static fromSerialized(json = {}) {
        return deserialize(OrderedOption, json);
    }
    static get serializeInfo() {
        return {
            extends: Actor.serializeInfo,
            props: {},
        };
    }
    static get stripInfo() {
        return {
            extends: Actor.stripInfo,
            props: {},
        };
    }
}
__decorate([
    memoize
], OrderedOption, "serializeInfo", null);
__decorate([
    memoize
], OrderedOption, "stripInfo", null);
